// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toasted-container[data-v-1bd0879e]{display:flex;flex-direction:column;gap:8px;position:fixed;left:0;right:0;bottom:0;z-index:1101;padding:0 10px 10px;box-sizing:border-box}.toasted-container[data-v-1bd0879e]:after{content:\"\";position:absolute;z-index:-1;top:-90px;left:0;bottom:0;right:0;pointer-events:none;background:linear-gradient(180deg,hsla(0,0%,100%,0),#fff 72.4%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
